<div class="mx-4 mt-2 mb-32">
  @if (isLoading) {
    <div class="flex flex-col gap-1.5" aria-hidden="true">
      @for (i of [1, 2, 3, 4, 5, 6, 7, 8]; track i) {
        <vw-skeleton-loader [width]="'100%'" [height]="'54px'" [borderRadius]="'1rem'"></vw-skeleton-loader>
      }
    </div>
  } @else if (loadError) {
    <div class="rounded-card bg-vw-surface px-4">
      <vw-error-state titleKey="calendar.error.title" messageKey="calendar.error.message" (retry)="retry.emit()"></vw-error-state>
    </div>
  } @else if (hierarchies.length > 0) {
    <div class="relative flex flex-col gap-1.5">
      @for (hierarchy of hierarchies; track hierarchy.uid) {
        <vw-calendar-hierarchy-card [hierarchy]="hierarchy" [badgeOf]="badgeOf"
          (cultivationSelected)="onCultivationSelected($event)"></vw-calendar-hierarchy-card>
      }
      <!-- Le trait d'aujourd'hui : un seul, du haut au bas de la liste, entre les cartes et à travers
           les familles dépliées. Il reprend les marges des cartes (bord, px-2, colonne du nom w-36,
           gap-2) pour tomber sur la grille des mois ; posé après les cartes, il passe devant elles.
           Le lecteur d'écran a son équivalent dans l'axe des mois (« mois en cours »). -->
      <div class="pointer-events-none absolute inset-0 flex gap-2 border border-transparent px-2" aria-hidden="true">
        <span class="w-36 shrink-0"></span>
        <span class="relative grow">
          <span class="today-line absolute inset-y-0 w-0.5 -translate-x-1/2 rounded-full bg-vw-ink" [style.left.%]="todayLeft"></span>
        </span>
      </div>
    </div>
  }
</div>
